<div class="form-section" dir="rtl">
  <div class="section-box">
    <div class="main-title">
      <h2>صلاحية التعامل</h2>
    </div>

    <div class="alert-container" style="margin-top: 20px;">
      <div class="alert-box">
        <span class="alert-icon">⚠️</span>
        <span class="alert-text">التوكيل لا بد أن يكون مصدق</span>
      </div>

      <div class="alert-box">
        <span class="alert-icon">⚠️</span>
        <span class="alert-text">في حالة الرغبة في تعديل البيانات الشخصية يتم ذلك من خلال صفحة تعديلات البيانات
          الشخصية</span>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="" style="margin-top: 100px;">
      <fieldset class="section-form readonly-fieldset">
        <!-- Name -->
        <!-- <div class="form-row">
                    <div class="form-field">
                        <label>الاسم <span class="required">*</span></label>
                        <input type="text" formControlName="name" aria-describedby="nameError" />
                        <div id="nameError" class="error"
                            *ngIf="form.get('name')?.touched && form.get('name')?.hasError('required') && !isReadOnly">
                            يرجى إدخال الاسم
                        </div>
                    </div>

                    <div class="form-field">
                        <label>الجنسية <span class="required">*</span></label>
                        <select formControlName="nationalityId" aria-describedby="nationalityError">
                            <option value="">-- اختر الجنسية --</option>
                        </select>
                        <div id="nationalityError" class="error"
                            *ngIf="form.get('nationalityId')?.touched && form.get('nationalityId')?.hasError('required') && !isReadOnly">
                            يرجى اختيار الجنسية
                        </div>
                    </div>


                </div> -->

        <!-- Identity Type & Dates -->
        <!-- <div class="form-row">

                    <div class="form-field">
                        <label>البريد الإلكتروني <span class="required">*</span></label>
                        <input type="email" formControlName="email" />
                    </div>

                    <div class="form-field">
                        <label>نوع إثبات الشخصية <span class="required">*</span></label>
                        <input type="text" />
                        <div id="identityTypeError" class="error"
                            *ngIf="form.get('identityTypeId')?.touched && form.get('identityTypeId')?.hasError('required') && !isReadOnly">
                            يرجى اختيار نوع إثبات الشخصية
                        </div>
                    </div>

                </div> -->

        <!-- <div class="form-row">
                    <div class="form-field">
                        <label> رقم اثبات الشخصية <span class="required">*</span></label>
                        <input type="text" placeholder="dd/mm/yyyy" formControlName="idNumber" />
                    </div>
                    <div class="form-field">
                        <label>رقم الموبايل <span class="required">*</span></label>
                        <input type="text" placeholder="dd/mm/yyyy" formControlName="phone" />
                    </div>
                </div> -->

        <!-- Contact -->
        <div class="form-row">
          <!-- <div class="form-field">
                        <label>تاريخ الميلاد <span class="required">*</span></label>
                        <input type="text" placeholder="dd/mm/yyyy" formControlName="birthDate" />
                    </div> -->

          <div class="form-field" style="position: relative;">
            <label>اسم الشركة <span class="required">*</span></label>

            <input type="text" formControlName="companyName" autocomplete="off" (input)="onInputChange($event)" />

            <select class="autocomplete" *ngIf="companies.length" size="2" (change)="onCompanyChange($event)">
              <option *ngFor="let c of companies" [ngValue]="c">
                {{ c.companyNameAr || c.companyNameEn }}
              </option>
            </select>

          </div>
          <div class="form-field">
            <label>المنطقة الحرة <span class="required">*</span></label>

            <select formControlName="freeZoneCode">
              <option value="">-- اختر المنطقة الحرة --</option>
              <option *ngFor="let zone of freeZones" [value]="zone.code">
                {{ zone.nameAr }}
              </option>
            </select>
          </div>




        </div>

        <!-- Company Related (optional) -->
        <div class="form-row">
          <div class="form-field">
            <label>صفة الممثل عن الشركة <span class="required">*</span></label>
            <select formControlName="boardPositionId">
              <option value="">-- من فضلك اختر --</option>
              <option *ngFor="let pos of boardPositions" [value]="pos.id">
                {{ pos.nameAr }}
              </option>
            </select>

          </div>
          <div class="form-field">
            <app-file-upload label="خطاب تفويض عليه صحة توقيع بنكي/توكيل " [required]="true"
              tooltipText="يجب رفع كافة صفحات المستند كاملة في ملف واحد PDF" acceptedTypes=".pdf"
              errorMessage="يرجى تحميل (PDF فقط)" formControlName="idDocument" filePath="{{ filePath }}"
              (uploadComplete)="onUploadComplete($event, 'idDocument')" (fileRemoved)="onFileRemoved('idDocument')">
            </app-file-upload>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <app-file-upload label="صورة اثبات الشخصية (البطاقة/جواز السفر) علي ان تكون سارية" [required]="true"
              tooltipText="يجب رفع كافة صفحات المستند كاملة في ملف واحد PDF" acceptedTypes=".pdf"
              errorMessage="يرجى تحميل (PDF فقط)" formControlName="identifierUrl" filePath="{{ filePath }}"
              (uploadComplete)="onUploadComplete($event, 'identifierUrl')"
              (fileRemoved)="onFileRemoved('identifierUrl')">
            </app-file-upload>
          </div>

          <div class="form-field">
            <app-file-upload label="مستخرج من السجل التجاري للشركة" [required]="true" acceptedTypes=".pdf"
              tooltipText="يجب رفع كافة صفحات المستند كاملة في ملف واحد PDF" acceptedTypes=".pdf"
              errorMessage="يرجى تحميل (PDF فقط)" formControlName="extractedCompanyCommercialUrl"
              filePath="{{ filePath }}" (uploadComplete)="onUploadComplete($event, 'extractedCompanyCommercialUrl')"
              (fileRemoved)="onFileRemoved('extractedCompanyCommercialUrl')">
            </app-file-upload>
          </div>

        </div>

        <div class="form-row">
          <div class="form-field">
            <label>رقم القيد في السجل التجاري</label>
            <input type="text" formControlName="registrationNumber" />
          </div>
          <div class="form-field">
            <label>مكتب السجل التجاري</label>
            <select formControlName="registryOfficeId">
              <option value="">-- من فضلك اختر --</option>
              <option *ngFor="let com of commercialOffices" [value]="com.id">
                {{ com.nameAr }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <label>رقم التسجيل الضريبي</label>
            <input type="text" formControlName="taxRegistrationNumber" />
          </div>
          <div class="form-field">
            <label>الشركة أجنبية أو أحد فروع البنوك الأجنبية</label>

            <select formControlName="isForeign">
              <option [ngValue]="false">-- من فضلك اختر --</option>
              <option [ngValue]="true">نعم</option>
              <option [ngValue]="false">لا</option>
            </select>
          </div>

        </div>

        <div class="form-row">
          <div class="form-field">
            <label>تاريخ مستخرج من السجل التجاري للشركة</label>
            <app-custom-date-input formControlName="commercialRegistryExtractionDate" [backgroundColor]="'white'"
              [validationType]="'past-only'">
            </app-custom-date-input>

          </div>
          <div class="form-field">
            <!-- Empty field to maintain layout balance -->
          </div>
        </div>

        <div class="form-row" style="display: flex;flex-direction: column;">
          <div class="form-row full" style="margin-top: 20px;">
            <label class="checkbox-label">
              <input type="checkbox" formControlName="declarationOne" />
              استلام اخطارات بكل الطلبات علي هذه الشركة
            </label>
          </div>

          <div class="form-row full">
            <label class="checkbox-label">
              <input type="checkbox" formControlName="declarationTwo" />
              اقر أني مسئول مسئولية تامة بإخطار الهيئة في حالة إنهاء الصلاحية </label>
          </div>

        </div>

        <div class="form-row"></div>
        <div class="form-row"></div>

        <!-- Actions -->
        <div class="form-actions">
          <button class="submit-btn" type="submit" [disabled]=" form.invalid || isSubmitDisabled">
            {{ isSubmitDisabled ? 'جاري الحفظ...' : 'حفظ' }}
          </button>
        </div>
      </fieldset>
    </form>
  </div>
</div>